//NOTE: Kendo dialog can't set the logo img on the title bar. So we need to customize the header
import './index.css'
import React from 'react'
import classNames from 'classnames'
import { SuccessIcon } from 'assets'
import iconError from 'assets/icons/fi_x-circle.png'

import { Typography } from '@mui/material'

const ModalTitle = props => {
  const { title, titleImg, onClose, version = 1, icon, closeIcon, content } = props
  if (version === 2)
    return (
      <div className="modal-title-wrapper">
        <div className="modal-title2">
          {icon === 'success' ? <SuccessIcon className="modal-title-img2" /> : null}
          {icon === 'error' ? <img src={iconError} alt="error" height={25} className="modal-title-img2" /> : null}
          {!!title && <h1 className="secondary-header text-bold color-primary modal-title-text2">{title}</h1>}
          {!!content && (
            <Typography variant="body1" sx={{ color: '#66668f', marginTop: '30px' }}>
              {content}
            </Typography>
          )}
        </div>
        {closeIcon === 'false' ? (
          ''
        ) : (
          <div className="k-icon k-i-x k-cursor-pointer modal-close2" onClick={onClose}></div>
        )}
      </div>
    )
  return (
    <div className={classNames('modal-title', { 'modal-title-no-img': !titleImg })}>
      {titleImg ? <img src={titleImg} alt="logo" height={25} className="modal-title-img" /> : <span></span>}
      {!!title && <span className="secondary-header text-bold color-primary modal-title-text">{title}</span>}
      <span className="k-icon k-i-x k-cursor-pointer modal-close" onClick={onClose}></span>
    </div>
  )
}

export default ModalTitle
